/*
  assets/search-sku-fallback.js
  ---------------------------------------------------------------------------
  A pedido (correo "Website issues", punto 3): un producto que se busca por SKU (ej. 3301186) no aparecía desde la
  barra de búsqueda — "No results". El buscador nativo de Shopify no indexa el SKU de este catálogo, pero la
  Storefront API sí encuentra el producto por SKU con una consulta de texto simple.

  Este respaldo SOLO actúa cuando la búsqueda nativa no devolvió nada y lo escrito parece un SKU (tiene algún dígito):
    - Página de resultados (/search) vacía: si hay un único producto con ese SKU se abre directo; si hay varios, los lista.
    - Desplegable de la barra de búsqueda: reemplaza el aviso "No results" por los productos encontrados.
  Solo se muestran productos cuyo SKU coincide de verdad con lo escrito (se ignora mayúsculas, espacios y guiones).
  Los productos Get A Quote no muestran precio (window.CSQuote.hidesPrice, assets/quote-products.js).
*/
(function () {
  'use strict';

  var CFG = window.CS_SEARCH_FALLBACK || {};
  if (!CFG.domain || !CFG.token) return;

  var ENDPOINT = 'https://' + CFG.domain + '/api/' + (CFG.version || '2026-07') + '/graphql.json';
  var QUERY =
    'query($q: String!) { products(first: 8, query: $q) { nodes {' +
    ' handle title vendor productType tags onlineStoreUrl' +
    ' featuredImage { url(transform: {maxWidth: 160, maxHeight: 160}) altText }' +
    ' priceRange { minVariantPrice { amount } }' +
    ' quoteBody: metafield(namespace: "spec", key: "body_material") { value }' +
    ' quoteDev: metafield(namespace: "spec", key: "device_type") { value }' +
    ' variants(first: 50) { nodes { sku } }' +
    ' } } }';

  var cache = {};

  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }

  function looksLikeSku(q) {
    return q.length >= 3 && q.length <= 40 && /\d/.test(q) && /^[\w .#\/-]+$/.test(q);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(amount) {
    var n = parseFloat(amount);
    if (!isFinite(n)) return '';
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  // Devuelve una promesa con los productos cuyo SKU coincide con q.
  function lookup(q) {
    var key = norm(q);
    if (cache[key]) return cache[key];
    cache[key] = fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': CFG.token },
      body: JSON.stringify({ query: QUERY, variables: { q: q } })
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var nodes = (j && j.data && j.data.products && j.data.products.nodes) || [];
        return nodes.filter(function (p) {
          if (!p.onlineStoreUrl) return false;
          return (p.variants.nodes || []).some(function (v) {
            var s = norm(v.sku);
            return s && (s === key || (key.length >= 5 && s.indexOf(key) !== -1));
          });
        });
      })
      .catch(function () { return []; });
    return cache[key];
  }

  function relUrl(u) {
    try { var x = new URL(u); return x.pathname + x.search; } catch (e) { return u; }
  }

  function itemHtml(p) {
    var hide = window.CSQuote && window.CSQuote.hidesPrice({
      handle: p.handle, title: p.title, vendor: p.vendor, productType: p.productType, tags: p.tags,
      priceRange: p.priceRange, quoteBody: p.quoteBody, quoteDev: p.quoteDev
    });
    var price = hide ? '' : '<span class="search-bar__item-price">' + esc(money(p.priceRange.minVariantPrice.amount)) + '</span>';
    var img = p.featuredImage
      ? '<div class="search-bar__image-container"><div class="aspect-ratio aspect-ratio--square"><img src="' + esc(p.featuredImage.url) + '" alt="' + esc(p.featuredImage.altText || '') + '"></div></div>'
      : '';
    return '<a href="' + esc(relUrl(p.onlineStoreUrl)) + '" class="search-bar__result-item">' + img +
      '<div class="search-bar__item-info"><p class="search-bar__item-title">' + esc(p.title) + '</p>' + price + '</div></a>';
  }

  /* ---------- Desplegable de la barra de búsqueda ---------- */
  function fixDropdown(empty) {
    if (!empty || empty.getAttribute('data-sku-fallback')) return;
    var input = document.querySelector('.search-bar__input');
    var q = input ? input.value.trim() : '';
    if (!looksLikeSku(q)) return;
    empty.setAttribute('data-sku-fallback', '1');
    lookup(q).then(function (products) {
      if (!products.length) return;
      // si el usuario ya cambió el texto, no se pinta un resultado viejo
      var cur = input ? input.value.trim() : '';
      if (norm(cur) !== norm(q) || !empty.isConnected) return;
      empty.innerHTML =
        '<p class="search-bar__result-category">Products</p>' +
        '<div class="search-bar__result-products">' + products.map(itemHtml).join('') + '</div>';
      empty.classList.remove('search-bar__empty-state');
    });
  }

  /* ---------- Página de resultados vacía ---------- */
  function fixResultsPage() {
    if (location.pathname.replace(/\/+$/, '') !== '/search') return;
    var empty = document.querySelector('.empty-state');
    if (!empty || empty.getAttribute('data-sku-fallback')) return;
    var q = (new URLSearchParams(location.search).get('q') || '').trim();
    if (!looksLikeSku(q)) return;
    empty.setAttribute('data-sku-fallback', '1');
    lookup(q).then(function (products) {
      if (!products.length) return;
      if (products.length === 1) { location.replace(relUrl(products[0].onlineStoreUrl)); return; }
      var wrap = document.createElement('div');
      wrap.className = 'search-bar__result-products';
      wrap.style.cssText = 'max-width:640px;margin:24px auto;text-align:left';
      wrap.innerHTML = products.map(itemHtml).join('');
      empty.insertBefore(wrap, empty.querySelector('.empty-state__quick-form') || null);
      var desc = empty.querySelector('.empty-state__description');
      if (desc) desc.textContent = 'Products found for SKU "' + q + '":';
    });
  }

  function scan() {
    fixDropdown(document.querySelector('.search-bar__empty-state'));
  }

  document.addEventListener('DOMContentLoaded', function () {
    fixResultsPage();
    scan();
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  });
})();
